import React, {ReactElement} from 'react';
import OpenAndCloseArrow from '@fo/designSystem/OpenAndCloseArrow/OpenAndCloseArrow';
import PlusMinusExpand from '@fo/designSystem/PlusMinusExpand/PlusMinusExpand';

export enum AccordionItemIconVariation {
  ARROW = 'ARROW',
  PLUS_MINUS = 'PLUS_MINUS',
}

interface Props {
  variation?: AccordionItemIconVariation;
  isOpen?: boolean;
}

function AccordionItemIcon({variation = AccordionItemIconVariation.ARROW, isOpen}: Props): ReactElement {
  switch (variation) {
    case AccordionItemIconVariation.ARROW:
      return <OpenAndCloseArrow isOpen={isOpen} />;
    case AccordionItemIconVariation.PLUS_MINUS:
      return <PlusMinusExpand isOpen={isOpen} />;

    default:
      return <OpenAndCloseArrow isOpen={isOpen} />;
  }
}

export default AccordionItemIcon;
